// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16i55","question":"styles_question__N-4x0","inputVisibleButton":"styles_inputVisibleButton__fIv95","note":"styles_note__3nl2E"};